/* DowcPickerComponent.js */

"use strict";
const Renderer = require("./DowcPickerRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class DowcPickerComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
}
module.exports = DowcPickerComponent;
